<script>import { getContext } from "svelte";
import BuilderContext from "../../context/builder.context";
import ComponentsContext from "../../context/components.context";
import Block from "../block/block.svelte";
import BlocksWrapper from "./blocks-wrapper.svelte";
export let blocks;
export let parent;
export let path;
export let styleProp;
export let context = undefined;
export let linkComponent = undefined;
export let registeredComponents = undefined;
let builderContext = getContext(BuilderContext.key);
let componentsContext = getContext(ComponentsContext.key);
</script>

<BlocksWrapper
  {blocks}
  {parent}
  {path}
  {styleProp}
  BlocksWrapper={$context?.BlocksWrapper || $builderContext.BlocksWrapper}
  BlocksWrapperProps={$context?.BlocksWrapperProps ||
    $builderContext.BlocksWrapperProps}
>
  {#if blocks}
    {#each blocks as block (block.id)}
      <Block
        {block}
        {linkComponent}
        context={context || builderContext}
        registeredComponents={registeredComponents ||
          componentsContext.registeredComponents}
      />
    {/each}
  {/if}</BlocksWrapper
>